import { render } from "./PantrySelectCategory.vue?vue&type=template&id=0a62774c&scoped=true&ts=true"
import script from "./PantrySelectCategory.vue?vue&type=script&lang=ts"
export * from "./PantrySelectCategory.vue?vue&type=script&lang=ts"

import "./PantrySelectCategory.vue?vue&type=style&index=0&id=0a62774c&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a62774c"]])

export default __exports__